var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgCheckmarkBadgeOutline = function SvgCheckmarkBadgeOutline(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeWidth: 3,
    d: "M37.981 38H38m-.019 0c-1.245 1.235-3.502.927-5.085.927-1.943 0-2.879.38-4.265 1.767C27.45 41.874 25.867 44 24 44s-3.45-2.125-4.63-3.306c-1.387-1.387-2.323-1.767-4.266-1.767-1.583 0-3.84.308-5.085-.927-1.255-1.245-.946-3.511-.946-5.104 0-2.013-.44-2.939-1.874-4.372C5.066 26.39 4 25.324 4 24c0-1.325 1.066-2.391 3.199-4.524 1.28-1.28 1.874-2.547 1.874-4.372 0-1.583-.308-3.84.927-5.085 1.245-1.255 3.511-.946 5.104-.946 1.825 0 3.093-.595 4.372-1.874C21.61 5.066 22.675 4 24 4s2.391 1.066 4.524 3.199c1.279 1.28 2.547 1.874 4.372 1.874 1.583 0 3.84-.308 5.085.927 1.255 1.245.946 3.511.946 5.104 0 2.013.44 2.939 1.874 4.372C42.934 21.61 44 22.675 44 24s-1.066 2.391-3.199 4.524c-1.433 1.433-1.874 2.359-1.874 4.372 0 1.593.31 3.86-.946 5.104Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    stroke: "#B0C9E2",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 3,
    d: "M18 25.786s2.4 1.303 3.6 3.214c0 0 3.6-7.5 8.4-10"
  })));
};
export default SvgCheckmarkBadgeOutline;